export default __webpack_public_path__ + "static/media/apple-store.1a9a4188.png";